import React from 'react'
import { Link } from "react-router-dom";

const Footer = () => {
    return (
      <div className="bg-gray-800 border-t border-gray-200">
      <div className="max-w-screen-xl mx-auto py-12 px-4 overflow-hidden sm:px-6 lg:px-8">
        <nav className="-mx-5 -my-2 flex flex-wrap justify-center">
          <div className="px-5 py-2">
          <Link
            to="/philosophers" className="text-base leading-6 text-gray-300 hover:text-white">
                Philosophers
          </Link>
          </div>
          <div className="px-5 py-2">
          <Link
            to="/topics" className="text-base leading-6 text-gray-300 hover:text-white">
                Topics
          </Link>
          </div>
          <div className="px-5 py-2">
          <Link
            to="/random" className="text-base leading-6 text-gray-300 hover:text-white">
                Random
          </Link>
          </div>
          <div className="px-5 py-2">
          <Link
            to="/all" className="text-base leading-6 text-gray-300 hover:text-white">
                All Quotes
          </Link>
          </div>
          <div className="px-5 py-2">
          <Link
            to="/api" className="text-base leading-6 text-gray-300 hover:text-white">
                API
          </Link>
          </div>
         
        </nav>
      
        <div className="mt-8 relative flex justify-center">
          <a href="https://davmc.com" alt="David McGregor" className="text-gray-400 hover:text-white">
            <span >
              &copy; {new Date().getFullYear()} David McGregor
              <div className="ml-1 inline-flex align-bottom">
                <svg viewBox="0 0 20 20" fill="currentColor" className="link w-6 h-6"><path fillRule="evenodd" d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z" clipRule="evenodd"></path></svg>
              </div>
              </span>
            </a>
        </div>
        </div>
    </div>
    )
}

export default Footer
